import { postApiDevicechallengeValidatedevicechallenge } from "./postApiDevicechallengeValidatedevicechallenge";

export function deviceChallengeController() {
  return { postApiDevicechallengeValidatedevicechallenge };
}
